module.exports = __webpack_public_path__ + "static/media/step5_ex.5a63cfd4.png";